import { render, staticRenderFns } from "./Audio_dtail.vue?vue&type=template&id=50e794a8&scoped=true"
import script from "./Audio_dtail.vue?vue&type=script&lang=js"
export * from "./Audio_dtail.vue?vue&type=script&lang=js"
import style0 from "./Audio_dtail.vue?vue&type=style&index=0&id=50e794a8&prod&lang=scss&scoped=true"
import style1 from "./Audio_dtail.vue?vue&type=style&index=1&id=50e794a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e794a8",
  null
  
)

export default component.exports